import { actionCreator } from '../../helpers/utils';

export const SHOW = 'SHOW_BUSY_INDICATOR';
export const HIDE = 'HIDE_BUSY_INDICATOR';

export const show = () => async (dispatch) => {
    const showAction = actionCreator(SHOW);
    dispatch(showAction);
};

export const hide = () => async (dispatch) => {
    const hideAction = actionCreator(HIDE);
    dispatch(hideAction);
};



// WEBPACK FOOTER //
// ./containers/busy-indicator/busy-indicator-actions.js